class ParecerTecnicoController extends AbstractController
  @$inject = ['$injector', '$scope', '$uibModalInstance', 'pathService', 'parecerTecnicoService', 'excecao']

  constructor: ($injector, @scope, @modalInstance, pathService, @parecerTecnicoService, @excecao) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()

    @listOfParecerTecnico = []
    @parecer =
      excecao: angular.copy @excecao
      texto: ''

    @loadData()

  loadData: () ->
    parecer = angular.copy @parecer

    @loadingTracker.addPromise @parecerTecnicoService.getList(parecer, (result) =>
      if result.success
        @listOfParecerTecnico = result.data.items
      else
        @Alert.error('Ocorreu um erro ao buscar a lista de pareceres.', 'Erro!', false)
    )

  salvar: (form) ->
    return unless form.$valid
    parecer = angular.copy @parecer
    @submitTracker.addPromise @parecerTecnicoService.save(parecer, (result)=>
      if result.success
        Alert.success("Parecer adicionado com sucesso!", "Sucesso")
        @parecer.texto = ""
        form.$setPristine()
        @loadData()
      else
        Alert.warning("Por favor, entre em contato com o suporte técnico!", "Não foi possível efetuar o cadastro do parecer técnico.")
    )

  remover: (parecerTecnico)->
    Confirm.warning('Atenção', "Deseja realmente remover o parecer técnico ##{parecerTecnico.id} criado pelo #{parecerTecnico.autor.nome}?", {
      Sim: =>
        @parecerTecnicoService.delete(parecerTecnico.id, (result)=>
          if(result.success)
            Alert.success("O parecer técnico ##{parecerTecnico.id} criado pelo #{parecerTecnico.autor.nome} foi removido!.", 'Sucesso')
            @loadData()
          else
            Alert.error("Ocorreu um erro ao remover o parecer técnico ##{parecerTecnico.id}.")
        )
      Não: ''
    })

angular.module('eficienciaFiscalModule').controller('parecerTecnicoController', ParecerTecnicoController)